import { render, staticRenderFns } from "./CustomLogos.vue?vue&type=template&id=bd5cfe5a&scoped=true&"
import script from "./CustomLogos.vue?vue&type=script&lang=js&"
export * from "./CustomLogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5cfe5a",
  null
  
)

export default component.exports